<script setup>
import Event from '@/components/common/Event.vue';
import Alert    from '@/components/common/Alert.vue';
import axios  from "axios";
import moment  from "moment";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
  <v-card
    class="mx-auto"
    max-width="400"
    min-height="300"
  >
    <v-toolbar
        color="#E03532"    
        flat
        dark
    >
      <span class="text-h4">本日の予定</span>
      <v-spacer></v-spacer>
    <v-btn
        icon
        @click="schedule"
        dark
        depressed
    >
        <v-icon>
            mdi-plus
        </v-icon>
    </v-btn>

    <v-btn
        icon
        to="/cal"
        dark
        depressed
    >
        <v-icon>
            mdi-calendar-clock
        </v-icon>
    </v-btn>
    </v-toolbar>
    <v-card-text class="py-0" color="#F2F2F2" v-if="master_cal.length!=0">
      <v-timeline dense >
          <v-timeline-item
            v-for="item in master_cal"
            :key="item.id"
            :color="color[category_get(item.category)]"
            small
            fill-dot
          >
              <v-card> 
                <v-card-title :style="'background-color:'+color[category_get(item.category)]">
                    
                </v-card-title>
                <v-container>
                <v-row>
                    <v-col cols="4" class="pl-2 pr-1">
                        <span class="timefont">{{ schedule_time(item.start) }}</span>
                    </v-col>
                    <v-col class="px-1">
                    <a href="javascript:void(0)" @click="showEvent($event,item)">{{item.name}}</a>
                    </v-col>
                </v-row>
                </v-container>
              </v-card>
                  </v-timeline-item>
      </v-timeline>
    </v-card-text>
     <Alert 
        :message="message"
        :messagetitle="messagetitle"
        :messagetype="messagetype"
        blockheight = "300px"
        v-else
     >
      </Alert>
        <Event
            ref="schdl"
            :project="project"
            v-on:add-event   ="saveEvent($event)"
        />
  </v-card>
</template>
<script>

  export default {
    data: () => ({
      master_cal : [],
      color: ['#08415C','#42BFDD','#8380B6','#4FB477','#4A2040'],
      category: ['タスク','取材','イベント','プレスリリース','その他'],
      project : null,
      messagetype : 0,
      message     :"",
      messagetitle:"",
    }),

    methods: {
      category_get : function (cat){
        let num = 0;

        for(num = 0 ; num < this.category.length ; num++)
        {
            if(cat == this.category[num])
            {
                break;
            }
        }
        return num;
      },
        showEvent : function(event,data){
            data.color=this.color[this.category_get(data.category)];
            this.$refs.schdl.showEvent(event,data);
        },
        schedule : function(id) {
            this.selected_id = id;
            const date = moment().format("YYYY-MM-DD");
            this.$refs.schdl.showDial({"date":date,"category":"プレスリリース","time":moment().format("HH:00"),"hasTime":true});
        },
        schedule_time : function(start_date){
            return moment(start_date).format("HH:mm");
        },
        getEvent : async function(){
            var params = new URLSearchParams();
            let start = moment().format("YYYY-MM-DD");
            let end = start;
            params.append('start', start);
            params.append('end', end);
            await axios.post("https://qlipper.jp/api/events/get_cal.php",params)
            .then(response => {
                this.master_cal = response.data;
                if(this.master_cal.length==0)
                {
                    this.messagetitle = "本日の予定は登録されていません";
                    this.message      = "スケジュールを登録すれば反映されます";
                }
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        saveEvent : function(){
            this.getEvent();
        },
    },
    created : function(){
        this.getEvent();
        var params = new URLSearchParams();
        axios.post("https://qlipper.jp/api/events/get_project_dsp.php",params)
        .then(response => {
            this.project = response.data;
        }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
        });

    }
  }
</script>
<style>
.timefont{
    font-weight:bold;
}
</style>
